import { SELECIONAR_VIAGEM_IDA } from '../types';

export default function selecionarViagemIda (viagemIda) {
  return {
    type: SELECIONAR_VIAGEM_IDA,
    payload: viagemIda
  }
}
